import React from "react";
import {
  organizingCommittee,
  advisoryCommittee,
  technicalCommittee,
  jointorganizingCommittee,
  websiteCommittee,
  programmeCommittee,
} from "../data/mockData";

const Committee = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Page Header */}
      <div className="bg-gradient-to-r bg-blue-950 py-16 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider">
          COMMITTEE
        </h1>
        <div className="w-32 sm:w-48 h-1 bg-blue-600 mx-auto"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        {/* Organizing Committee Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl font-bold text-blue-950">
              ORGANIZING COMMITTEE
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {organizingCommittee.map((member) => (
              <div
                key={member.id}
                className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-primary-500"
              >
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-72 overflow-hidden"
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </a>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  <h3 className="text-lg font-bold text-blue-950 mb-1">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-700 transition-all duration-300"
                    >
                      {member.name}
                    </a>
                  </h3>

                  <p className="text-sm text-primary-600 font-semibold">
                    {member.designation}
                  </p>
                  <p className="text-xs text-gray-600 mt-1 leading-tight">
                    {member.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Joint Organizing Committee Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl font-bold text-blue-950">
              JOINT ORGANIZING COMMITTEE
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {jointorganizingCommittee.map((member) => (
              <div
                key={member.id}
                className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-primary-500"
              >
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-72 overflow-hidden"
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </a>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  <h3 className="text-lg font-bold text-blue-950 mb-1">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-700 transition-all duration-300"
                    >
                      {member.name}
                    </a>
                  </h3>
                  <p className="text-sm text-primary-600 font-semibold">
                    {member.designation}
                  </p>
                  <p className="text-xs text-gray-600 mt-1 leading-tight">
                    {member.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Technical Committee Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl font-bold text-blue-950">
              TECHNICAL COMMITTEE
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {technicalCommittee.map((member) => (
              <div
                key={member.id}
                className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-cyan-500"
              >
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-72 overflow-hidden"
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </a>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  <h3 className="text-lg font-bold text-blue-950 mb-1">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-700 transition-all duration-300"
                    >
                      {member.name}
                    </a>
                  </h3>
                  <p className="text-sm text-primary-600 font-semibold">
                    {member.designation}
                  </p>
                  <p className="text-xs text-gray-600 mt-1 leading-tight">
                    {member.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Advisory Committee Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl font-bold text-blue-950">
              ADVISORY COMMITTEE
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {advisoryCommittee.map((member) => (
              <div
                key={member.id}
                className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-500"
              >
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block h-72 overflow-hidden"
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </a>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  <h3 className="text-lg font-bold text-primary-900 mb-1">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-700 transition-all duration-300"
                    >
                      {member.name}
                    </a>
                  </h3>
                  <p className="text-sm text-primary-600 font-semibold">
                    {member.designation}
                  </p>
                  <p className="text-xs text-gray-600 mt-1 leading-tight">
                    {member.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Website Committee Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl font-bold text-blue-950">
              WEBSITE COMMITTEE
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {websiteCommittee.map((member) => (
              <div
                key={member.id}
                className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-500"
              >
                <div className="h-72 overflow-hidden">
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-300 cursor-pointer"
                    />
                  </a>
                </div>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  <h3 className="text-lg font-bold text-primary-900 mb-1">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-600 transition-colors duration-200"
                    >
                      {member.name}
                    </a>
                  </h3>

                  <p className="text-sm text-primary-600 font-semibold">
                    {member.designation}
                  </p>

                  <p className="text-xs text-gray-600 mt-1 leading-tight">
                    {member.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Programme Committee Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-primary-300 to-blue-200 p-6 sm:p-8 mb-12 text-center rounded-lg border-l-4 border-primary-600">
            <h2 className="text-3xl font-bold text-blue-950">
              PROGRAMME COMMITTEE
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {programmeCommittee.map((member) => (
              <div
                key={member.id}
                className="bg-gradient-to-br from-blue-100 to-blue-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-500"
              >
                <div className="h-72 overflow-hidden">
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-300 cursor-pointer"
                    />
                  </a>
                </div>

                <div className="p-4 text-center bg-gradient-to-br from-blue-100 to-blue-50">
                  <h3 className="text-lg font-bold text-primary-900 mb-1">
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-600 transition-colors duration-200"
                    >
                      {member.name}
                    </a>
                  </h3>

                  <p className="text-sm text-primary-600 font-semibold">
                    {member.designation}
                  </p>

                  <p className="text-xs text-gray-600 mt-1 leading-tight">
                    {member.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Committee;
